import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { FamilyProvider } from './contexts/FamilyContext';
import { DemoProvider } from './contexts/DemoContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { I18nProvider } from './contexts/I18nContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import NotificationCenter from './components/NotificationCenter';
import Login from './pages/Login';
import InstallDomus from './pages/InstallDomus';
import Register from './pages/Register';
import FamilyRegistration from './pages/FamilyRegistration';
import Dashboard from './pages/Dashboard';
import Tasks from './pages/Tasks';
import Finance from './pages/Finance';
import Shopping from './pages/Shopping';
import Calendar from './pages/Calendar';
import Health from './pages/Health';
import ItemsControl from './pages/ItemsControl';
import FamilyBoard from './pages/FamilyBoard';
import Settings from './pages/Settings';
import Profile from './pages/Profile';
import Locator from './pages/Locator';
import VideoRoom from './pages/VideoRoom';
import Chat from './pages/Chat';
import FamilyCalendar from './pages/FamilyCalendar';
import FamilyManagement from './pages/FamilyManagement';
import FamilyGeo from './pages/FamilyGeo'
import FavoriteSongs from './pages/FavoriteSongs'
import AnalyticsDashboard from './pages/AnalyticsDashboard'
import UserGuide from './pages/UserGuide'
import NotFound from './pages/NotFound'
import MobileNavigation from './components/MobileNavigation'
import { BottomNavigation } from './components/ResponsiveComponents'
import './App.css';

function EntryRoute() {
  const {user,isInitialized}=useAuth();
  if(!isInitialized)return <div className="p-8 text-center">A verificar o acesso ao DOMUS...</div>;
  return <Navigate to={user?"/dashboard":"/register"} replace/>;
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <DemoProvider>
          <FamilyProvider>
            <NotificationProvider>
              <I18nProvider>
                <div className="app">
                  <div className="notification-container">
                    <NotificationCenter />
                  </div>
                  <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/install" element={<InstallDomus />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/family-setup" element={<ProtectedRoute><FamilyRegistration /></ProtectedRoute>} />
                  <Route path="/" element={<EntryRoute />} />
                  
                  {/* Cada utilizador entra individualmente; não existe login coletivo da família. */}
                  {/* Dados e operações familiares exigem sessão */}
                  <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/tasks" element={<Tasks />} />
                    <Route path="/finance" element={<Finance />} />
                    <Route path="/shopping" element={<Shopping />} />
                    <Route path="/calendar" element={<Calendar />} />
                    <Route path="/health" element={<Health />} />
                    <Route path="/items-control" element={<ItemsControl />} />
                    <Route path="/family-board" element={<FamilyBoard />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/locator" element={<Locator />} />
                    <Route path="/video-room" element={<VideoRoom />} />
                    <Route path="/chat" element={<Chat />} />
                    <Route path="/family-calendar" element={<FamilyCalendar />} />
                    <Route path="/family-management" element={<FamilyManagement />} />
                    <Route path="/family-geo" element={<FamilyGeo />} />
                    <Route path="/favorite-songs" element={<FavoriteSongs />} />
                    <Route path="/analytics" element={<AnalyticsDashboard />} />
                    <Route path="/guide" element={<UserGuide />} />
                  </Route>
                  
                  <Route path="*" element={<NotFound />} />
                </Routes>
                
                {/* Navegação mobile */}
                <MobileNavigation />
                <BottomNavigation />
              </div>
              </I18nProvider>
            </NotificationProvider>
          </FamilyProvider>
        </DemoProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;